/**
 * this file is part of dawn and its logic maintained unmodified
 * modifications made are typehints only!
 */

window.Shopify.bind = function (fn: () => any, scope: any) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

window.Shopify.setSelectorByValue = function (selector: HTMLSelectElement, value: string) {
    for (let i = 0, count = selector.options.length; i < count; i++) {
        const option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

window.Shopify.addListener = function (target: HTMLElement, eventName: string, callback: () => void) {
    // @ts-ignore
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

window.Shopify.postLink = function (
    path: string,
    options: { method?: string; parameters?: { [key: string]: string } }
) {
    options = options || {};
    const method = options["method"] || "post";
    const params = options["parameters"] || {};

    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (const key in params) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

window.Shopify.CountryProvinceSelector = function (
    country_domid: string,
    province_domid: string,
    options: { hideElement?: string }
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

window.Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        const value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        const value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function () {
        var opt = this.countryEl.options[this.countryEl.selectedIndex] as HTMLOptionElement;
        const raw = opt.getAttribute("data-provinces");
        const provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (let i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector: HTMLSelectElement) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector: HTMLSelectElement, values: string[]) {
        for (let i = 0; i < values.length; i++) {
            const opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};
